const TIMER = 250

const viewport = () => {
  const sizes = {}

  const capture = () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    window.dispatchEvent(new Event('viewportchanged'))
  }

  let timeout

  const handler = () => {
    clearTimeout(timeout)
    timeout = setTimeout(capture, TIMER)
  }

  // capture initial size
  capture()

  // bind resize handler
  window.addEventListener('resize', handler)

  // return sizes object
  return sizes
}

const singleton = viewport()

export default singleton
